import { BrowserPermission } from './browser-notification.port';

export type ToggleState = 'unsupported' | 'blocked' | 'off' | 'on';

/**
 * The browser permission and the app-level opt-in are separate conditions. Collapsing
 * them into one boolean is what makes "the browser blocks it" indistinguishable from
 * "I turned it off", so the template renders this derived state instead.
 */
export function deriveToggleState(
  supported: boolean,
  permission: BrowserPermission,
  optIn: boolean,
): ToggleState {
  if (!supported) {
    return 'unsupported';
  }
  if (permission === 'denied') {
    return 'blocked';
  }
  return optIn && permission === 'granted' ? 'on' : 'off';
}
